export default __webpack_public_path__ + "static/hero@mobile-ee8411e856b104ebb2b664ce38b9b464.jpg";